/** @format */

export enum TimerEventEnum {
    /**
     * Dispatched from Timer constructor
     */
    timerCreated = 'TIMER_CREATED',

    /**
     * Dispatched from Timer.start() method
     */
    timerStart = 'TIMER_START',

    /**
     * Dispatched from Timer.stop() method
     */
    timerStop = 'TIMER_STOP',

    /**
     * Dispatched on timer tick
     */
    timerTick = 'TIMER_TICK',

    /**
     * Dispatched on timer tick when iteration limit was reached and timer was stopped
     */
    timerTickLimit = 'TIMER_TICK_LIMIT',
}
